type UserGroup = TestRequestRaw.Schemas.Group;

export const userGroupDictionary: { [G in UserGroup]: string } = {
  APPROVER: "Approver",
};

export const UserGroupReverseDictionary: { [DisplayName: string]: UserGroup } = {
  Approver: "APPROVER",
};

export const userGroupOptions: UserGroup[] = ["APPROVER"];

export default UserGroup;
